import { useCallback } from 'react';
import { TServerSendRequest } from 'js/hooks/socket/types';

import { useGenericSend } from '../useGenericSend';

export const useChangeLoginSessionLanguage = () => {
    const send = useGenericSend();

    return useCallback((languageCode: string) => send<TServerSendRequest<{ languageCode: string }>>({
        ID: 35878,
        responses: [35879, 35880],
        description: 'Change Login Session Language',
        languageCode
    }), [send]);
};
